import { Button, Flex, HStack, Text } from "@chakra-ui/react";
import FilterSelect from "./FilterSelect";
import { PAGE_SIZE_OPTIONS } from "../clientsQuery";

const pageSizeItems = PAGE_SIZE_OPTIONS.map((n) => ({ value: String(n), label: `${n} / page` }));

/** Builds a compact "1 … 4 5 6 … 12" page list. */
const pageWindow = (current, total) => {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages = new Set([1, total, current, current - 1, current + 1]);
    const sorted = [...pages].filter((p) => p >= 1 && p <= total).sort((a, b) => a - b);
    const out = [];
    let prev = 0;
    for (const p of sorted) {
        if (p - prev > 1) out.push("…");
        out.push(p);
        prev = p;
    }
    return out;
};

const ClientsPagination = ({ page, pageSize, totalCount, onPageChange, onPageSizeChange }) => {
    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
    const from = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
    const to = Math.min(page * pageSize, totalCount);

    return (
        <Flex w="full" justify="space-between" align="center" gap={3} flexWrap="wrap" pt={1}>
            <Text color="text.grey" fontSize="sm">
                {totalCount === 0 ? "No companies" : `${from}–${to} of ${totalCount} companies`}
            </Text>
            <HStack gap={3} flexWrap="wrap">
                <HStack gap={1}>
                    <Button
                        size="sm"
                        variant="outlined"
                        onClick={() => onPageChange(page - 1)}
                        disabled={page <= 1}
                    >
                        Prev
                    </Button>
                    {pageWindow(page, totalPages).map((p, i) =>
                        p === "…" ? (
                            <Text key={`gap-${i}`} color="text.grey" px={1}>…</Text>
                        ) : (
                            <Button
                                key={p}
                                size="sm"
                                variant={p === page ? "primary" : "outlined"}
                                onClick={() => onPageChange(p)}
                                minW="36px"
                            >
                                {p}
                            </Button>
                        )
                    )}
                    <Button
                        size="sm"
                        variant="outlined"
                        onClick={() => onPageChange(page + 1)}
                        disabled={page >= totalPages}
                    >
                        Next
                    </Button>
                </HStack>
                <FilterSelect
                    label="Show"
                    value={String(pageSize)}
                    options={pageSizeItems}
                    onChange={(v) => onPageSizeChange(parseInt(v, 10))}
                    width="140px"
                />
            </HStack>
        </Flex>
    );
};

export default ClientsPagination;
